import { TmdxAvatar } from '@ds';
import { AoAssignmentStatus, DriverAssignmentStatus } from '@/api/apis/drive-service';
import { TripAssignmentStatusChip } from './TripAssignmentStatusChip';

type TripAssignmentCardProps = {
  type: 'ao' | 'driver' | 'vehicle';
  image?: string | null;
  title: string;
  subtitle?: string;
  status?: DriverAssignmentStatus | AoAssignmentStatus;
};

export const TripAssignmentCard = ({ type, title, subtitle, status, image }: TripAssignmentCardProps) => {
  const isVehicle = type === 'vehicle';
  const isDriver = type === 'driver';

  const showAvatar = isVehicle || isDriver;

  return (
    <div className="w-1/3 flex gap-2 p-2 rounded-lg bg-base-70">
      {showAvatar && (
        <TmdxAvatar
          size="md"
          radius="md"
          name={isDriver ? title : ''}
          color={isVehicle ? 'secondary' : 'default'}
          src={image || ''}
          type={isVehicle ? 'car' : 'user'}
        />
      )}
      <div className="flex flex-col gap-1">
        <div className="flex flex-col">
          <span className="text-s-sb text-black">{title}</span>
          {!!subtitle && <span className="text-s-r text-base-10">{subtitle}</span>}
        </div>
        {!!status && <TripAssignmentStatusChip status={status} />}
      </div>
    </div>
  );
};
